/*@jsxRuntime automatic @jsxImportSource react*/
/*import node_modules*/
/*import types*/
/*import components*/
/*import config*/
/*define layout*/
/*Navbar*/
/*define content*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Heading, Spacer} from '@storylinerlabs/design';
import {RouteEnum} from '../types';
import Column from '../components/atoms/Column';
import Content from '../components/atoms/Content';
import EarlyAccessSection from '../components/elements/EarlyAccessSection';
import LocalMarkdown from '../components/atoms/LocalMarkdown';
import MainLayout from '../components/layouts/MainLayout';
import SEO from '../components/meta/SEO';
import Section from '../components/atoms/Section';
import {storylinerRootDomain} from '../../config';
const MDXLayout = ({children}) => _jsxs(MainLayout, {
  children: [_jsx(SEO, {
    description: "Terms of service of Storyliner Labs GmbH. Read now …",
    hrefLang: RouteEnum.WEBSITE_TERMS_OF_SERVICE_DE,
    image: `${storylinerRootDomain}/img/screensavers/screensaver-break-creative-barriers-storyliner.jpg`,
    title: "Terms of service - Storyliner"
  }), _jsxs(Section, {
    children: [_jsx(Spacer, {
      height: "64px"
    }), _jsx(Spacer, {
      height: "50px"
    })]
  }), _jsx(Section, {
    children: _jsx(Column, {
      cols: "md",
      children: _jsx(LocalMarkdown, {
        children: children
      })
    })
  }), _jsx(Section, {
    children: _jsx(Spacer, {
      height: "50px"
    })
  }), _jsx(Section, {
    bgColor: "desertStorm",
    children: _jsx(Spacer, {
      height: "100px"
    })
  }), _jsx(EarlyAccessSection, {
    bgColor: "desertStorm"
  }), _jsx(Section, {
    bgColor: "desertStorm",
    children: _jsx(Spacer, {
      height: "100px"
    })
  }), _jsx(Section, {
    children: _jsx(Spacer, {
      height: "50px"
    })
  })]
});
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: ["\n", "\n", "\n", "\n", "\n", "\n", "\n", "\n", "\n", "\n", "\n", _jsx(_components.h1, {
      children: "Terms of Service"
    }), "\n", _jsx(_components.p, {
      children: "The terms of Servcie are being revised and will be available again soon. Please come back later …"
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
